/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import { Grid, Box, Typography, Avatar, Divider } from '@mui/material';
import './FnfARModal.css';
import CustomModal from '../../CustomModal/CustomModal';
import ModalHeader from '../../CustomModal/ModalHeader';
import CustomTextField from '../../../components/CustomTextField/CustomTextField';
import CompDirection from '../../../themes/CompDirection';
import { themes } from '../../../themes/themes';
import TakeActionSplitBtn from '../../../components/TakeActionSplitBtn/TakeActionSplitBtn';
import { getAmount } from '../../../configs/utils';
import { DateField } from '../../../../components';
import { baseDateFormatting } from '../../../helper';

interface ModalProps {
  isModalOpen?: boolean;
  closeModal: any;
  trans?: any;
  fullData?: any;
  allActions?: any;
  userId?: any;
  handleSubmitAR_Request?: any;
}

const FnfARModalPresenter = ({
  isModalOpen,
  closeModal,
  fullData,
  trans,
  allActions,
  handleSubmitAR_Request,
  userId,
}: ModalProps) => {
  const getFormatedDurationFromDays: any = (numberOfDays: any) => {
    const years = Math.floor(numberOfDays / 365);
    const months = Math.floor((numberOfDays % 365) / 30);
    const days = Math.floor((numberOfDays % 365) % 30);

    return years + 'Y,' + months + 'M,' + days + 'D';
  };

  const handleTakeAction = (x: any) => {
    if (x) {
      const payload = {
        event: 'claims',
        instanceId: fullData?.id,
        userId: userId,
        action: x ? x : '',
        context: {},
        model: 'emp_claims',
      };
      handleSubmitAR_Request(payload);
    } else {
      return;
    }
  };

  return (
    <CustomModal isModalOpen={isModalOpen} modalHeight="98vh" modalWidth="72vw">
      <ModalHeader
        modal={{ modal_title: trans('FnF Action Required') }}
        closeModal={closeModal}
      />
      <CompDirection>
        <Grid
          container
          spacing={2}
          style={{
            marginTop: '5px',
          }}
        >
          <Grid item xs={3}>
            <Box className="bg_border_ar_fnf">
              {/* {Employee Intro Box} */}
              <Box
                style={{
                  padding: '1em',
                  border: '1px solid #0000001f',
                  borderRadius: '10px',
                }}
              >
                <Box
                  style={{
                    display: 'flex',
                    alignItems: 'flex-start',
                    justifyContent: 'space-between',
                  }}
                >
                  <Box>
                    <Typography
                      style={{
                        fontFamily: 'Lato',
                        fontSize: '0.7em',
                        color: themes.greyDefault_500,
                        border: '1px solid #9E9E9E',
                        borderRadius: '4px',
                        padding: '4px',
                        alignSelf: 'center',
                      }}
                    >
                      {' '}
                      #{fullData?.fnf_settlement?.employee?.staff_id}
                    </Typography>
                  </Box>
                  <Box
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      justifyContent: 'center',
                    }}
                  >
                    <Avatar style={{ height: '3em', width: '3em' }} />
                    <Typography
                      style={{
                        fontFamily: 'Lato',
                        fontSize: '1em',
                        fontWeight: 'bold',
                        color: themes.darkBlue,
                      }}
                    >
                      {fullData?.fnf_settlement?.employee?.first_name}{' '}
                      {fullData?.fnf_settlement?.employee?.last_name}
                    </Typography>
                    <Typography
                      style={{
                        fontFamily: 'Lato',
                        fontSize: '0.7em',
                        color: themes.greyModalTitle,
                      }}
                    >
                      {
                        fullData?.fnf_settlement?.employee?.emp_job_detail
                          ?.designation?.name
                      }
                    </Typography>
                  </Box>
                  <Box>
                    <Typography>
                      <i
                        className="las la-ellipsis-h"
                        color={themes.greyDefault_500}
                        style={{ height: '1em', width: '1em' }}
                      />
                    </Typography>
                  </Box>
                </Box>
                <Box
                  style={{
                    display: 'flex',
                    padding: '1em',
                    marginTop: '0.5em',
                    width: 'auto',
                    backgroundColor: '#F5F5FA66',
                    height: 'auto',
                    borderRadius: '10px',
                    flexDirection: 'column',
                  }}
                >
                  <Box
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      marginTop: '0.5em',
                    }}
                  >
                    <Typography
                      style={{
                        fontFamily: 'Lato',
                        fontSize: '0.7em',
                        color: themes.greyModalTitle,
                      }}
                    >
                      Department
                    </Typography>
                    <Typography
                      style={{
                        fontFamily: 'Lato',
                        fontSize: '0.7em',
                        color: themes.greyModalTitle,
                      }}
                    >
                      Date Hired
                    </Typography>
                  </Box>
                  <Box
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      marginTop: '5px',
                    }}
                  >
                    <Typography
                      style={{
                        fontFamily: 'Lato',
                        fontSize: '0.7em',
                        fontWeight: 'bold',
                        color: themes.darkBlue,
                      }}
                    >
                      {
                        fullData?.fnf_settlement?.employee?.emp_job_detail
                          ?.department?.name
                      }
                    </Typography>
                    <Typography
                      style={{
                        fontFamily: 'Lato',
                        fontSize: '0.7em',
                        fontWeight: 'bold',
                        color: themes.darkBlue,
                      }}
                    >
                      <DateField
                        value={
                          fullData?.fnf_settlement?.employee?.emp_job_detail
                            ?.hire_date
                        }
                        format={baseDateFormatting}
                      />
                    </Typography>
                  </Box>
                  <Divider style={{ marginTop: '0.5em' }} />
                  <Box
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      marginTop: '0.5em',
                    }}
                  >
                    <Box>
                      <Typography
                        style={{
                          fontFamily: 'Lato',
                          fontSize: '0.7em',
                          color: themes.greyModalTitle,
                        }}
                      >
                        <i className="las la-envelope-open" />{' '}
                        {fullData?.fnf_settlement?.employee?.email}
                      </Typography>
                      <Typography
                        style={{
                          fontFamily: 'Lato',
                          fontSize: '0.7em',
                          color: themes.greyModalTitle,
                        }}
                      >
                        <i className="las la-phone-volume" />
                        {fullData?.fnf_settlement?.employee?.phone}
                      </Typography>
                    </Box>
                    <Box>
                      <Typography
                        style={{
                          fontFamily: 'Lato',
                          fontSize: '0.7em',
                          color: '#21D8A5',
                          backgroundColor: '#E8FBF6',
                          padding: '5px',
                          alignSelf: 'center',
                          borderRadius: '4px',
                        }}
                      >
                        {fullData?.fnf_settlement?.employee?.is_active == 1
                          ? 'Active'
                          : 'In Active'}
                      </Typography>
                    </Box>
                  </Box>
                </Box>
              </Box>

              {/* {Net Payment} */}

              <Box
                style={{
                  marginTop: '1em',
                  border: '1px solid #0000001f',
                  borderRadius: '8px',
                  padding: '0.75em',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                }}
              >
                <Typography
                  style={{
                    fontFamily: 'Lato',
                    fontSize: '0.75em',
                    fontWeight: 'bold',
                    color: themes.primaryMain,
                  }}
                >
                  {' '}
                  FnF Payment{' '}
                </Typography>
                <Typography
                  style={{
                    fontFamily: 'Lato',
                    fontSize: '0.75em',
                    fontWeight: 'bold',
                    color: themes.primaryMain,
                  }}
                >
                  {' '}
                  {fullData?.fnf_settlement?.paid_gross_salary +
                    fullData?.fnf_settlement?.gratuity +
                    fullData?.fnf_settlement?.net_addition_deduction +
                    fullData?.fnf_settlement?.leave_fnf}
                </Typography>
              </Box>
              <Box style={{ marginTop: '1em' }}>
                <CustomTextField
                  type="string"
                  label="Comment"
                  placeholder="Write Comment"
                />
              </Box>
              <Box style={{ marginTop: '1.5em', zIndex: '999', width: '100%' }}>
                <TakeActionSplitBtn
                  onAction={(x: any) => handleTakeAction(x)}
                  menu={allActions}
                  title={'Take Action'}
                />
              </Box>
            </Box>
          </Grid>
          {/* {Second Column} */}
          <Grid item xs={3}>
            <Box className="bg_border_ar_fnf_with_border">
              <Typography
                style={{
                  fontFamily: 'Lato',
                  fontSize: '0.85em',
                  fontWeight: 'bold',
                  color: themes.primaryMain,
                }}
              >
                Gratuity Calculations
              </Typography>
              <Box
                style={{
                  display: 'flex',
                  padding: '0.5em',
                  marginTop: '0.5em',
                  width: 'auto',
                  backgroundColor: '#F5F5FA66',
                  height: '20px',
                  borderRadius: '5px',
                  flexDirection: 'column',
                }}
              >
                <Box
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    marginTop: '5px',
                  }}
                >
                  <Typography
                    style={{
                      fontFamily: 'Lato',
                      fontSize: '12px',
                      color: themes.greySubtitle,
                    }}
                  >
                    Hire Date
                  </Typography>
                  <Typography
                    style={{
                      fontFamily: 'Lato',
                      fontSize: '12px',
                      fontWeight: 'bold',
                      color: themes.greySubtitle,
                    }}
                  >
                    {
                      fullData?.fnf_settlement?.employee?.emp_job_detail
                        ?.hire_date
                    }
                  </Typography>
                </Box>
              </Box>
              <Box
                style={{
                  display: 'flex',
                  padding: '0.5em',
                  marginTop: '0.5em',
                  width: 'auto',
                  backgroundColor: '#F5F5FA66',
                  height: '20px',
                  borderRadius: '5px',
                  flexDirection: 'column',
                }}
              >
                <Box
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    marginTop: '5px',
                  }}
                >
                  <Typography
                    style={{
                      fontFamily: 'Lato',
                      fontSize: '12px',
                      color: themes.greySubtitle,
                    }}
                  >
                    Exit Date
                  </Typography>
                  <Typography
                    style={{
                      fontFamily: 'Lato',
                      fontSize: '12px',
                      fontWeight: 'bold',
                      color: themes.greySubtitle,
                    }}
                  >
                    {fullData?.fnf_settlement?.emp_offboarding?.date}
                  </Typography>
                </Box>
              </Box>
              <Box
                style={{
                  display: 'flex',
                  padding: '0.5em',
                  marginTop: '0.5em',
                  width: 'auto',
                  backgroundColor: '#F5F5FA66',
                  height: '20px',
                  borderRadius: '5px',
                  flexDirection: 'column',
                }}
              >
                <Box
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    marginTop: '5px',
                  }}
                >
                  <Typography
                    style={{
                      fontFamily: 'Lato',
                      fontSize: '12px',
                      color: themes.greySubtitle,
                    }}
                  >
                    Exit Type
                  </Typography>
                  <Typography
                    style={{
                      fontFamily: 'Lato',
                      fontSize: '12px',
                      fontWeight: 'bold',
                      color: themes.greySubtitle,
                    }}
                  >
                    {fullData?.fnf_settlement?.emp_offboarding?.type}
                  </Typography>
                </Box>
              </Box>
              <Box
                style={{
                  display: 'flex',
                  padding: '0.5em',
                  marginTop: '0.5em',
                  width: 'auto',
                  backgroundColor: '#F5F5FA66',
                  height: '20px',
                  borderRadius: '5px',
                  flexDirection: 'column',
                }}
              >
                <Box
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    marginTop: '5px',
                  }}
                >
                  <Typography
                    style={{
                      fontFamily: 'Lato',
                      fontSize: '12px',
                      color: themes.greySubtitle,
                    }}
                  >
                    Type of Contract
                  </Typography>
                  <Typography
                    style={{
                      fontFamily: 'Lato',
                      fontSize: '12px',
                      fontWeight: 'bold',
                      color: themes.greySubtitle,
                    }}
                  >
                    {
                      fullData?.fnf_settlement?.employee?.emp_job_detail
                        ?.contract_type?.name
                    }
                  </Typography>
                </Box>
              </Box>
              <Box
                style={{
                  display: 'flex',
                  padding: '0.5em',
                  marginTop: '0.5em',
                  width: 'auto',
                  backgroundColor: '#F5F5FA66',
                  height: '20px',
                  borderRadius: '5px',
                  flexDirection: 'column',
                }}
              >
                <Box
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    marginTop: '5px',
                  }}
                >
                  <Typography
                    style={{
                      fontFamily: 'Lato',
                      fontSize: '12px',
                      color: themes.greySubtitle,
                    }}
                  >
                    Exit Policy Excluding LOP?
                  </Typography>
                  <Typography
                    style={{
                      fontFamily: 'Lato',
                      fontSize: '12px',
                      fontWeight: 'bold',
                      color: themes.greySubtitle,
                    }}
                  >
                    {fullData?.fnf_settlement?.exit_policy?.include_lop == 1
                      ? 'Yes'
                      : 'No'}
                  </Typography>
                </Box>
              </Box>
              <Box
                style={{
                  display: 'flex',
                  padding: '0.5em',
                  marginTop: '0.5em',
                  width: 'auto',
                  backgroundColor: '#F5F5FA66',
                  height: '20px',
                  borderRadius: '5px',
                  flexDirection: 'column',
                }}
              >
                <Box
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    marginTop: '5px',
                  }}
                >
                  <Typography
                    style={{
                      fontFamily: 'Lato',
                      fontSize: '12px',
                      color: themes.greySubtitle,
                    }}
                  >
                    Number of unauthorized leave
                  </Typography>
                  <Typography
                    style={{
                      fontFamily: 'Lato',
                      fontSize: '12px',
                      fontWeight: 'bold',
                      color: themes.greySubtitle,
                    }}
                  >
                    {fullData?.fnf_settlement?.unauthorized_leaves}
                  </Typography>
                </Box>
              </Box>
              <Box
                style={{
                  display: 'flex',
                  padding: '0.5em',
                  marginTop: '0.5em',
                  width: 'auto',
                  backgroundColor: '#F5F5FA66',
                  height: '20px',
                  borderRadius: '5px',
                  flexDirection: 'column',
                }}
              >
                <Box
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    marginTop: '5px',
                  }}
                >
                  <Typography
                    style={{
                      fontFamily: 'Lato',
                      fontSize: '12px',
                      color: themes.greySubtitle,
                    }}
                  >
                    Actual Tenure
                  </Typography>
                  <Typography
                    style={{
                      fontFamily: 'Lato',
                      fontSize: '12px',
                      fontWeight: 'bold',
                      color: themes.greySubtitle,
                    }}
                  >
                    {getFormatedDurationFromDays(
                      fullData?.fnf_settlement?.actutal_tenure,
                    )}
                  </Typography>
                </Box>
              </Box>
              <Box
                style={{
                  display: 'flex',
                  padding: '0.5em',
                  marginTop: '0.5em',
                  width: 'auto',
                  backgroundColor: '#F5F5FA66',
                  height: '20px',
                  borderRadius: '5px',
                  flexDirection: 'column',
                }}
              >
                <Box
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    marginTop: '5px',
                  }}
                >
                  <Typography
                    style={{
                      fontFamily: 'Lato',
                      fontSize: '12px',
                      color: themes.greySubtitle,
                    }}
                  >
                    Total Tenure
                  </Typography>
                  <Typography
                    style={{
                      fontFamily: 'Lato',
                      fontSize: '12px',
                      fontWeight: 'bold',
                      color: themes.greySubtitle,
                    }}
                  >
                    {getFormatedDurationFromDays(
                      fullData?.fnf_settlement?.total_tenure,
                    )}
                  </Typography>
                </Box>
              </Box>
              <Box
                style={{
                  display: 'flex',
                  padding: '0.5em',
                  marginTop: '0.5em',
                  width: 'auto',
                  backgroundColor: '#F5F5FA66',
                  height: '20px',
                  borderRadius: '5px',
                  flexDirection: 'column',
                }}
              >
                <Box
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    marginTop: '5px',
                  }}
                >
                  <Typography
                    style={{
                      fontFamily: 'Lato',
                      fontSize: '12px',
                      color: themes.greySubtitle,
                    }}
                  >
                    Total Gratuity
                  </Typography>
                  <Typography
                    style={{
                      fontFamily: 'Lato',
                      fontSize: '12px',
                      fontWeight: 'bold',
                      color: themes.primaryMain,
                    }}
                  >
                    {fullData?.fnf_settlement?.gratuity}
                  </Typography>
                </Box>
              </Box>
            </Box>
          </Grid>
          {/* {3rd Column} */}
          <Grid item xs={3}>
            <Box
              style={{
                display: 'flex',
                flexDirection: 'column',
                maxHeight: '64vh',
                height: 'auto',
              }}
            >
              <Box className="bg_border_ar_fnf_with_HALF_border">
                <Typography
                  style={{
                    fontFamily: 'Lato',
                    fontSize: '0.85em',
                    fontWeight: 'bold',
                    color: themes.primaryMain,
                  }}
                >
                  Addition/Deduction Calculations
                </Typography>
                <Box
                  style={{
                    display: 'flex',
                    padding: '0.5em',
                    marginTop: '0.5em',
                    width: 'auto',
                    backgroundColor: '#F5F5FA66',
                    height: '20px',
                    borderRadius: '5px',
                    flexDirection: 'column',
                  }}
                >
                  <Box
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      marginTop: '5px',
                    }}
                  >
                    <Typography
                      style={{
                        fontFamily: 'Lato',
                        fontSize: '12px',
                        color: themes.greySubtitle,
                      }}
                    >
                      Offcycle
                    </Typography>
                    <Typography
                      style={{
                        fontFamily: 'Lato',
                        fontSize: '12px',
                        fontWeight: 'bold',
                        color: themes.greySubtitle,
                      }}
                    >
                      {fullData?.fnf_settlement?.off_cycle}
                    </Typography>
                  </Box>
                </Box>
                <Box
                  style={{
                    display: 'flex',
                    padding: '0.5em',
                    marginTop: '0.5em',
                    width: 'auto',
                    backgroundColor: '#F5F5FA66',
                    height: '20px',
                    borderRadius: '5px',
                    flexDirection: 'column',
                  }}
                >
                  <Box
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      marginTop: '5px',
                    }}
                  >
                    <Typography
                      style={{
                        fontFamily: 'Lato',
                        fontSize: '12px',
                        color: themes.greySubtitle,
                      }}
                    >
                      Overtime
                    </Typography>
                    <Typography
                      style={{
                        fontFamily: 'Lato',
                        fontSize: '12px',
                        fontWeight: 'bold',
                        color: themes.greySubtitle,
                      }}
                    >
                      {fullData?.fnf_settlement?.overtime}
                    </Typography>
                  </Box>
                </Box>
                <Box
                  style={{
                    display: 'flex',
                    padding: '0.5em',
                    marginTop: '0.5em',
                    width: 'auto',
                    backgroundColor: '#F5F5FA66',
                    height: '20px',
                    borderRadius: '5px',
                    flexDirection: 'column',
                  }}
                >
                  <Box
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      marginTop: '5px',
                    }}
                  >
                    <Typography
                      style={{
                        fontFamily: 'Lato',
                        fontSize: '12px',
                        color: themes.greySubtitle,
                      }}
                    >
                      Recurring Payment
                    </Typography>
                    <Typography
                      style={{
                        fontFamily: 'Lato',
                        fontSize: '12px',
                        fontWeight: 'bold',
                        color: themes.greySubtitle,
                      }}
                    >
                      {fullData?.fnf_settlement?.recurring_payment}
                    </Typography>
                  </Box>
                </Box>

                <Box
                  style={{
                    display: 'flex',
                    padding: '0.5em',
                    marginTop: '0.5em',
                    width: 'auto',
                    backgroundColor: '#F5F5FA66',
                    height: '20px',
                    borderRadius: '5px',
                    flexDirection: 'column',
                  }}
                >
                  <Box
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      marginTop: '5px',
                    }}
                  >
                    <Typography
                      style={{
                        fontFamily: 'Lato',
                        fontSize: '12px',
                        color: themes.greySubtitle,
                      }}
                    >
                      Total Amount
                    </Typography>
                    <Typography
                      style={{
                        fontFamily: 'Lato',
                        fontSize: '12px',
                        fontWeight: 'bold',
                        color: themes.primaryMain,
                      }}
                    >
                      {fullData?.fnf_settlement?.net_addition_deduction
                        ? getAmount(
                            fullData?.fnf_settlement?.net_addition_deduction,
                          )
                        : 0}
                    </Typography>
                  </Box>
                </Box>
              </Box>
              <Box style={{ marginTop: '1em' }} />
              <Box className="bg_border_ar_fnf_with_HALF_border">
                <Typography
                  style={{
                    fontFamily: 'Lato',
                    fontSize: '0.85em',
                    fontWeight: 'bold',
                    color: themes.primaryMain,
                  }}
                >
                  Leave FnF Calculations
                </Typography>
                <Box
                  style={{
                    display: 'flex',
                    padding: '0.5em',
                    marginTop: '0.5em',
                    width: 'auto',
                    backgroundColor: '#F5F5FA66',
                    height: '20px',
                    borderRadius: '5px',
                    flexDirection: 'column',
                  }}
                >
                  <Box
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      marginTop: '5px',
                    }}
                  >
                    <Typography
                      style={{
                        fontFamily: 'Lato',
                        fontSize: '12px',
                        color: themes.greySubtitle,
                      }}
                    >
                      Annual Leave Balance
                    </Typography>
                    <Typography
                      style={{
                        fontFamily: 'Lato',
                        fontSize: '12px',
                        fontWeight: 'bold',
                        color: themes.greySubtitle,
                      }}
                    >
                      {fullData?.fnf_settlement?.leave_balance} Days
                    </Typography>
                  </Box>
                </Box>
                <Box
                  style={{
                    display: 'flex',
                    padding: '0.5em',
                    marginTop: '0.5em',
                    width: 'auto',
                    backgroundColor: '#F5F5FA66',
                    height: '20px',
                    borderRadius: '5px',
                    flexDirection: 'column',
                  }}
                >
                  <Box
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      marginTop: '5px',
                    }}
                  >
                    <Typography
                      style={{
                        fontFamily: 'Lato',
                        fontSize: '12px',
                        color: themes.greySubtitle,
                      }}
                    >
                      Per Day Amount
                    </Typography>
                    <Typography
                      style={{
                        fontFamily: 'Lato',
                        fontSize: '12px',
                        fontWeight: 'bold',
                        color: themes.greySubtitle,
                      }}
                    >
                      {fullData?.fnf_settlement?.per_day_salary}
                    </Typography>
                  </Box>
                </Box>

                <Box
                  style={{
                    display: 'flex',
                    padding: '0.5em',
                    marginTop: '0.5em',
                    width: 'auto',
                    backgroundColor: '#F5F5FA66',
                    height: '20px',
                    borderRadius: '5px',
                    flexDirection: 'column',
                  }}
                >
                  <Box
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      marginTop: '5px',
                    }}
                  >
                    <Typography
                      style={{
                        fontFamily: 'Lato',
                        fontSize: '12px',
                        color: themes.greySubtitle,
                      }}
                    >
                      Total Leave Amount
                    </Typography>
                    <Typography
                      style={{
                        fontFamily: 'Lato',
                        fontSize: '12px',
                        fontWeight: 'bold',
                        color: themes.primaryMain,
                      }}
                    >
                      {getAmount(fullData?.fnf_settlement?.leave_fnf)}
                    </Typography>
                  </Box>
                </Box>
              </Box>
            </Box>
          </Grid>
          {/* {4th Column} */}
          <Grid item xs={3}>
            <Box className="bg_border_ar_fnf_with_border">
              <Typography
                style={{
                  fontFamily: 'Lato',
                  fontSize: '0.85em',
                  fontWeight: 'bold',
                  color: themes.primaryMain,
                }}
              >
                Salary Calculations
              </Typography>
              <Box
                style={{
                  display: 'flex',
                  padding: '0.5em',
                  marginTop: '0.5em',
                  width: 'auto',
                  backgroundColor: '#F5F5FA66',
                  height: '20px',
                  borderRadius: '5px',
                  flexDirection: 'column',
                }}
              >
                <Box
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    marginTop: '5px',
                  }}
                >
                  <Typography
                    style={{
                      fontFamily: 'Lato',
                      fontSize: '12px',
                      color: themes.greySubtitle,
                    }}
                  >
                    Start Date
                  </Typography>
                  <Typography
                    style={{
                      fontFamily: 'Lato',
                      fontSize: '12px',
                      fontWeight: 'bold',
                      color: themes.greySubtitle,
                    }}
                  >
                    {fullData?.fnf_settlement?.start_date}
                  </Typography>
                </Box>
              </Box>
              <Box
                style={{
                  display: 'flex',
                  padding: '0.5em',
                  marginTop: '0.5em',
                  width: 'auto',
                  backgroundColor: '#F5F5FA66',
                  height: '20px',
                  borderRadius: '5px',
                  flexDirection: 'column',
                }}
              >
                <Box
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    marginTop: '5px',
                  }}
                >
                  <Typography
                    style={{
                      fontFamily: 'Lato',
                      fontSize: '12px',
                      color: themes.greySubtitle,
                    }}
                  >
                    End Date
                  </Typography>
                  <Typography
                    style={{
                      fontFamily: 'Lato',
                      fontSize: '12px',
                      fontWeight: 'bold',
                      color: themes.greySubtitle,
                    }}
                  >
                    {fullData?.fnf_settlement?.end_date}
                  </Typography>
                </Box>
              </Box>
              <Box
                style={{
                  display: 'flex',
                  padding: '0.5em',
                  marginTop: '0.5em',
                  width: 'auto',
                  backgroundColor: '#F5F5FA66',
                  height: '20px',
                  borderRadius: '5px',
                  flexDirection: 'column',
                }}
              >
                <Box
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    marginTop: '5px',
                  }}
                >
                  <Typography
                    style={{
                      fontFamily: 'Lato',
                      fontSize: '12px',
                      color: themes.greySubtitle,
                    }}
                  >
                    Total Amount
                  </Typography>
                  <Typography
                    style={{
                      fontFamily: 'Lato',
                      fontSize: '12px',
                      fontWeight: 'bold',
                      color: themes.greySubtitle,
                    }}
                  >
                    {fullData?.fnf_settlement?.payroll_salary}
                  </Typography>
                </Box>
              </Box>

              <Box
                style={{
                  display: 'flex',
                  padding: '0.5em',
                  marginTop: '0.5em',
                  width: 'auto',
                  backgroundColor: '#F5F5FA66',
                  height: '20px',
                  borderRadius: '5px',
                  flexDirection: 'column',
                }}
              >
                <Box
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    marginTop: '5px',
                  }}
                >
                  <Typography
                    style={{
                      fontFamily: 'Lato',
                      fontSize: '12px',
                      color: themes.greySubtitle,
                    }}
                  >
                    Total Tax
                  </Typography>
                  <Typography
                    style={{
                      fontFamily: 'Lato',
                      fontSize: '12px',
                      fontWeight: 'bold',
                      color: themes.primaryMain,
                    }}
                  >
                    {getAmount(fullData?.fnf_settlement?.total_tax)}
                  </Typography>
                </Box>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </CompDirection>
    </CustomModal>
  );
};

export default FnfARModalPresenter;
